import Cookie from "js-cookie";
import api from "@/api";

const SET_CART = "SET_CART";
const RESET_CART = "RESET_CART";
const CART_TOKEN = "cart_token";

export default {
  namespaced: true,
  state: {
    tokenValue: null,
    items: [],
    total: {},
  },
  getters: {
    cart: ({ items, total }) => ({
      items,
      total,
    }),
    tokenValue: () => {
      return Cookie.get(CART_TOKEN);
    },
  },
  actions: {
    async getCart({ commit, state }) {
      let res = await api.cart.get(Cookie.get(CART_TOKEN));

      commit(SET_CART, res.data);
      return res;
    },
    reset({ commit }) {
      commit(RESET_CART);
    },
  },
  mutations: {
    [SET_CART](state, cart) {
      state.items = cart.items || [];
      state.total = cart.total || {};
    },
    [RESET_CART](state) {
      Cookie.remove(CART_TOKEN);
      state.items = [];
      state.total = {};
    },
  },
};
